import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router";

// Función para verificar si el usuario tiene alguna de las funcionalidades requeridas
const tieneFuncionalidad = (usuario, funcionalidadesRequeridas) => {
  if (!usuario || !usuario.funciones) return false;
  return funcionalidadesRequeridas.some((funcRequerida) =>
    usuario.funciones.some((func) => func.descripcion === funcRequerida)
  );
};

export default function ProtectedLink({ funcionalidadesRequeridas, children }) {
  const storedAuth = localStorage.getItem("auth");

  let usuario = null;
  let isAuthenticated = false;

  if (storedAuth) {
    try {
      const parsedAuth = JSON.parse(storedAuth);
      if (parsedAuth?.usuario && parsedAuth?.token) {
        usuario = parsedAuth.usuario;
        isAuthenticated = true;
      }
    } catch (error) {
      console.error("Error parsing stored auth data:", error);
    }
  }

  // Verifica si el usuario tiene al menos una de las funcionalidades requeridas
  const tieneAcceso = tieneFuncionalidad(usuario, funcionalidadesRequeridas);

  if (!tieneAcceso) {
    return <></>;
  }

  // Renderiza las rutas hijas y el contenido adicional
  return (
    <>
      {children}
      <Outlet />
    </>
  );
}
